import { createContext, useState, useCallback, useEffect } from "react";
import useMounted from "../hooks/useMounted";
import studentService from "../../src/UIS_services/StudentService/studentService";
import toast from "react-hot-toast";
import useAuth from "../../src/hooks/useAuth";

const AvatarContext = createContext("");

export const AvatarProvider = ({ children }) => {
    const [avatar, Setavatar] = useState("");
    const mounted = useMounted();
    const { user } = useAuth();

    const InitalData = useCallback(async () => {
        try {
            let userCurrent = localStorage.getItem("authorizationData");

            if (userCurrent) {
                if (JSON.parse(userCurrent).Role == "SV") {
                    let data = await studentService.GetAvatar();
                    if (mounted.current && data) {
                        Setavatar(data.data);
                    }
                }
            }
        } catch (error) {
            console.log(error);
            // toast.error(error.response.data);
        }
    }, [mounted, user]);
    useEffect(() => {
        InitalData();
    }, [InitalData]);
    return (
        <AvatarContext.Provider value={avatar}>
            {children}
        </AvatarContext.Provider>
    );
};
export default AvatarContext;
